import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface ExchangeRateTabProps {
  formMode: FormMode;
  editExchangeRate: boolean;
  onEditExchangeRateChange: (value: boolean) => void;
}

export const ExchangeRateTab: React.FC<ExchangeRateTabProps> = ({
  formMode,
  editExchangeRate,
  onEditExchangeRateChange
}) => {
  return (
    <div className='flex items-center gap-12 p-4'>
      <Label className='text-sm font-medium'>Sửa tỷ giá ghi sổ</Label>
      <Checkbox
        id='tg_dd'
        checked={editExchangeRate}
        onCheckedChange={checked => onEditExchangeRateChange(checked as boolean)}
        disabled={formMode === 'view'}
      />
    </div>
  );
};
